<template>
  <div class="move-father-box" @click="hideMoveFile(false)" v-show="moveFile">
    <div @click.stop="hideMoveFile(true)" class="move-child-box">
      <div class="box-header">创建导图</div>
      <img
        class="close-icon"
        @click.stop="hideMoveFile(false)"
        src="../../assets/img/groupImg/close-modal.png"
        alt=""
      />
      <div class="created-content-box menu-silder">
          <div v-for="(item, index) in templateData" :key="index" class="modal-class">
            <template v-if="index < 4">
              <div class="modal-class-name">
                {{ getString(item[0].name )}}
              </div>
              <NewCreatedFileScroll
                :data="item"
                @clickCreated="clickCreated"
                :folder="crumbs.slice(-1)[0]"
              />
            </template>
            <template v-else>
              <div class="modal-class-name">
                {{ getString(item[0].name )}}
              </div>
              <CreatedFileScroll
                :data="item"
                @clickCreated="clickCreated"
                :folder="crumbs.slice(-1)[0]"
              />
            </template>
                <!-- <div class="modal-class-name">
                    {{ getString(item[0].name )}}
                </div>
                <CreatedFileScroll
                    :data="item"
                /> -->
            </div>
      </div>
    </div>
  </div>
</template>

<script>


import HttpServerConfig from "../../common/HttpServerConfig";
import timestampToTime from "../../utils/timestampToTime";

import { postTemplateNewFromTemplate } from "../../common/netWork/template_api";
import CreatMindItmeData from "../../views/uidata/CreatMindItmeData";

import LineLayout from "../../viewmodel/datatype/LineLayout";
import MindDisplayType from "../../viewmodel/datatype/MindDisplayType";
import MindType from "../../viewmodel/datatype/MindType";
import NodeLayoutType from "../../viewmodel/datatype/NodeLayoutType";

import CreatedFileScroll from "./CreatedFileScroll";
import NewCreatedFileScroll from "./NewCreatedFileScroll";
import Strings from "../../common/lang/strings";
import getString from "../../common/lang/language";
import createdMindData from "../../common/createdMindData";

export default {
  name: "MoveFile",
  props: ["moveFile", ],
  components: {
    CreatedFileScroll,
    NewCreatedFileScroll,
  },
  data() {
    return {
      templateData: [],
      creatMindTypeLeftRight: [],
      creatMindTypeUnilateral: [],
      creatMindTypeBottom: [],
      creatMindTypeBubble: [],
      creatMindTypeTimeVertical: [],
      urlPrefix: "../../../static/img/mapIcon/res/mipmap-xxhdpi/", //地址前缀
      crumbs: [{ id: "", name: getString(Strings.Create_Map) }], //面包屑
    };
  },
    created() {
      this.templateData = createdMindData
    // this.createdType();
    //创建页面时要请求vuex里面的面包屑
    //this.crumbs = this.$store.state.createdMindCrumbsArr;
  },
  methods: {
    getString(i) {
      return getString(i);
    },
    pullModalData(obj) {
      let that = this;
      return new Promise(function (resolve, reject) {
        postTemplateNewFromTemplate(
          obj,
          (res) => {
            resolve(res);
          },
          (error) => {
            reject(error);
            that.$message.error(error.desc);
          }
        );
      });
    },
    clickCreated(item) {
        this.hideMoveFile(false, true);
      // this.bus.$emit("changeCreated", item);

    },
    createdType() {
      this.creatMindTypeLeftRight.push(
        new CreatMindItmeData(
          "left_right_layout_empty.jpg",
          Strings.My_Mind_Type_Left_Right,
          NodeLayoutType.LAYOUT_RIGHT_LEFT_CLOCKWISE,
          MindType.LINE_MAP,
          1.333,
          3,
          LineLayout.CURVE_LINE_2,
          MindDisplayType.MindMap,
          true
        )
      );
      this.creatMindTypeLeftRight.push(
        new CreatMindItmeData(
          "left_right_layout_7.jpg",
          "双向导图",
          NodeLayoutType.LAYOUT_RIGHT_LEFT_CLOCKWISE,
          MindType.LINE_MAP,
          1.333,
          37,
          LineLayout.CURVE_LINE,
          MindDisplayType.MindMap,
          false,
          "发散思维模型"
        )
      );
      this.creatMindTypeLeftRight.push(
        new CreatMindItmeData(
          "free_tree_layout_1.png",
          "双向导图",
          NodeLayoutType.LAYOUT_FREE_TREE,
          MindType.LINE_MAP,
          1.333,
          38,
          LineLayout.CURVE_LINE,
          MindDisplayType.MindMap,
          false,
          "发散思维_流线型"
        )
      );
      this.creatMindTypeLeftRight.push(
        new CreatMindItmeData(
          "left_right_layout_3.jpg",
          "双向导图",
          NodeLayoutType.LAYOUT_RIGHT_LEFT_CLOCKWISE,
          MindType.LINE_MAP,
          1.333,
          2,
          LineLayout.RIGHT_ANGLE_CORNER_LINE,
          MindDisplayType.MindMap,
          false,
          "发散思维_规整型"
        )
      );
      this.creatMindTypeLeftRight.push(
        new CreatMindItmeData(
          "left_right_layout_4.jpg",
          "双向导图",
          NodeLayoutType.LAYOUT_TREE_LEFT_RIGHT,
          MindType.LINE_MAP,
          1.333,
          21,
          LineLayout.RIGHT_ANGLE_CORNER_ARROW_LINE,
          MindDisplayType.MindMap,
          false,
          "发散思维_流线型"
        )
      );
      this.creatMindTypeLeftRight.push(
        new CreatMindItmeData(
          "left_right_layout_5.jpg",
          "双向导图",
          NodeLayoutType.LAYOUT_TREE_LEFT_RIGHT,
          MindType.LINE_MAP,
          1.333,
          22,
          LineLayout.RIGHT_ANGLE_LINE,
          MindDisplayType.MindMap,
          false,
          "传递性和顺序性"
        )
      );
      this.creatMindTypeLeftRight.push(
        new CreatMindItmeData(
          "left_right_layout_6.jpg",
          "双向导图",
          NodeLayoutType.LAYOUT_RIGHT_LEFT_CLOCKWISE,
          MindType.LINE_MAP,
          1.333,
          35,
          LineLayout.CURVE_LINE_2,
          MindDisplayType.MindMap,
          false,
          "发散思维模型"
        )
      );
      this.creatMindTypeUnilateral.push(
        new CreatMindItmeData(
          "layout_right_3.jpg",
          Strings.My_Mind_Type_Unilateral,
          NodeLayoutType.LAYOUT_FISH_RIGHT,
          MindType.LINE_MAP,
          1.333,
          5,
          LineLayout.CURVE_LINE_2,
          MindDisplayType.MindMap,
          false,
          "因果分析"
        )
      );
      //form_horizontal_layout_1.png
      this.creatMindTypeUnilateral.push(
        new CreatMindItmeData(
          "form_horizontal_layout_1.png", 
          "单向导图",
          NodeLayoutType.LAYOUT_FORM_HORIZONTAL,
          MindType.LINE_MAP,
          1.333,
          5,
          LineLayout.STRAIGHT_LINE_2,
          MindDisplayType.MindMap,
          false,
          "各部门业务流程"
        )
      );
      this.creatMindTypeUnilateral.push(
        new CreatMindItmeData(
          "form_horizontal_layout_1.png", 
          "单向导图",
          NodeLayoutType.LAYOUT_BRIDGE,
          MindType.TIME_MAP,
          1.333,
          5,
          LineLayout.STRAIGHT_LINE_2,
          MindDisplayType.MindMap,
          false,
          "类比相似性"
        )
      );
      this.creatMindTypeUnilateral.push(
        new CreatMindItmeData(
          "layout_right_1.jpg", 
          "单向导图",
          NodeLayoutType.LAYOUT_RIGHT,
          MindType.LINE_MAP,
          1.333,
          6,
          LineLayout.STRAIGHT_LINE_2,
          MindDisplayType.MindMap,
          false,
          "对事物延伸分析"
        )
      );
      this.creatMindTypeUnilateral.push(
        new CreatMindItmeData(
          "layout_right_2.png",
          "单向导图",
          NodeLayoutType.LAYOUT_BRACKETS_RIGHT,
          MindType.LINE_MAP,
          1.333,
          36,
          LineLayout.RIGHT_ANGLE_CORNER_LINE,
          MindDisplayType.MindMap,
          false,
          "中心主题拆开分析"
        )
      );
      this.creatMindTypeUnilateral.push(
        new CreatMindItmeData(
          "layout_right_4.png",
          "单向导图",
          NodeLayoutType.LAYOUT_TREE_RIGHT,
          MindType.LINE_MAP,
          1.333,
          23,
          LineLayout.RIGHT_ANGLE_LINE,
          MindDisplayType.MindMap,
          false,
          "顺序性和全局性"
        )
      );
      this.creatMindTypeUnilateral.push(
        new CreatMindItmeData(
          "layout_right_5.png",
          "单向导图",
          NodeLayoutType.LAYOUT_TREE_LEFT,
          MindType.LINE_MAP,
          1.333,
          24,
          LineLayout.RIGHT_ANGLE_CORNER_ARROW_LINE,
          MindDisplayType.MindMap,
          false,
          "顺序性和全局性"
        )
      );
      this.creatMindTypeUnilateral.push(
        new CreatMindItmeData(
          "layout_right_6.png",
          "单向导图",
          NodeLayoutType.LAYOUT_LEFT,
          MindType.LINE_MAP,
          1.333,
          25,
          LineLayout.RIGHT_ANGLE_CORNER_ARROW_LINE,
          MindDisplayType.MindMap,
          false,
          "对事物延伸分析"
        )
      );

      this.creatMindTypeBottom.push(
        new CreatMindItmeData(
          "layout_bottom_1.jpg",
          Strings.My_Mind_Type_Bottom,
          NodeLayoutType.LAYOUT_BOTTOM,
          MindType.LINE_MAP,
          1.333,
          9,
          LineLayout.RIGHT_ANGLE_CORNER_LINE,
          MindDisplayType.MindMap,
          false,
          "向下组织架构"
        )
      );
      this.creatMindTypeBottom.push(
        new CreatMindItmeData(
          "layout_bottom_2.jpg",
          "组织架构图",
          NodeLayoutType.LAYOUT_BOTTOM,
          MindType.LINE_MAP,
          1.333,
          10,
          LineLayout.RIGHT_ANGLE_CORNER_LINE,
          MindDisplayType.MindMap,
          false,
          "向下组织架构"
        )
      );
      this.creatMindTypeBottom.push(
        new CreatMindItmeData(
          "layout_bottom_3.jpg",
          "组织架构图",
          NodeLayoutType.LAYOUT_BOTTOM,
          MindType.LINE_MAP,
          1.333,
          11,
          LineLayout.RIGHT_ANGLE_CORNER_LINE,
          MindDisplayType.MindMap,
          false,
          "向下组织架构"
        )
      );
      this.creatMindTypeBottom.push(
        new CreatMindItmeData(
          "layout_bottom_4.png",
          "组织架构图",
          NodeLayoutType.LAYOUT_BOTTOM,
          MindType.LINE_MAP,
          1.333,
          26,
          LineLayout.FULL_RIGHT_ANGLE_CORNER_LINE,
          MindDisplayType.MindMap,
          false,
          "向下组织架构"
        )
      );
      this.creatMindTypeBottom.push(
        new CreatMindItmeData(
          "layout_bottom_5.png",
          "组织架构图",
          NodeLayoutType.LAYOUT_BOTTOM,
          MindType.LINE_MAP,
          1.333,
          27,
          LineLayout.FULL_RIGHT_ANGLE_CORNER_LINE,
          MindDisplayType.MindMap,
          false,
          "向下组织架构"
        )
      );
      this.creatMindTypeBottom.push(
        new CreatMindItmeData(
          "layout_bottom_6.png",
          "组织架构图",
          NodeLayoutType.LAYOUT_BOTTOM,
          MindType.LINE_MAP,
          1.333,
          28,
          LineLayout.RIGHT_ANGLE_LINE,
          MindDisplayType.MindMap,
          false,
          "向下组织架构"
        )
      );

      this.creatMindTypeBubble.push(
        new CreatMindItmeData(
          "bubble_layout_1.svg",
          Strings.My_Mind_Type_Bubble,
          NodeLayoutType.LAYOUT_BUBBLE,
          MindType.BUBBLE_MAP,
          1.333,
          4,
          LineLayout.STRAIGHT_LINE,
          MindDisplayType.MindMap,
          false,
          "特征描绘"
        )
      );
      this.creatMindTypeBubble.push(
        new CreatMindItmeData(
          "circular_layout.svg",
          "气泡图",
          NodeLayoutType.LAYOUT_CIRCLE,
          MindType.LINE_MAP,
          1.333,
          7,
          LineLayout.STRAIGHT_LINE,
          MindDisplayType.MindMap,
          false,
          "特征描绘"
        )
      );
      this.creatMindTypeBubble.push(
        new CreatMindItmeData(
          "double_bubble_layout_1.svg",
          "气泡图",
          NodeLayoutType.LAYOUT_LEFT_RIGHT,
          MindType.DOUBLE_BUBBLE_MAP,
          1.333,
          0,
          LineLayout.STRAIGHT_LINE,
          MindDisplayType.MindMap,
          false,
          "对比共性和特性"
        )
      );
      this.creatMindTypeBubble.push(
        new CreatMindItmeData(
          "double_bubble_layout_2.svg",
          "气泡图",
          NodeLayoutType.LAYOUT_LEFT_RIGHT,
          MindType.DOUBLE_BUBBLE_MAP,
          1.333,
          29,
          LineLayout.STRAIGHT_LINE,
          MindDisplayType.MindMap,
          false,
          "对比共性和特性"
        )
      );
      this.creatMindTypeBubble.push(
        new CreatMindItmeData(
          "bubble_layout_4.svg",
          "气泡图",
          NodeLayoutType.LAYOUT_BUBBLE,
          MindType.BUBBLE_MAP,
          1.333,
          30,
          LineLayout.STRAIGHT_LINE,
          MindDisplayType.MindMap,
          false,
          "特征描绘"
        )
      );
      this.creatMindTypeBubble.push(
        new CreatMindItmeData(
          "bubble_layout_5.svg",
          "气泡图",
          NodeLayoutType.LAYOUT_BUBBLE,
          MindType.BUBBLE_MAP,
          1.333,
          31,
          LineLayout.STRAIGHT_LINE,
          MindDisplayType.MindMap,
          false,
          "特征描绘"
        )
      );

      this.creatMindTypeTimeVertical.push(
        new CreatMindItmeData(
          "vertical_layout_1.jpg",
          Strings.My_Mind_Type_Time_Vertical,
          NodeLayoutType.LAYOUT_VERTICAL,
          MindType.TIME_MAP,
          1,
          12,
          LineLayout.STRAIGHT_LINE,
          MindDisplayType.MindMap,
          false,
          "竖向时间线"
        )
      );
      this.creatMindTypeTimeVertical.push(
        new CreatMindItmeData(
          "vertical_layout_3.jpg",
          "日程安排图",
          NodeLayoutType.LAYOUT_HORIZONTAL,
          MindType.TIME_MAP,
          1,
          12,
          LineLayout.STRAIGHT_LINE,
          MindDisplayType.MindMap,
          false,
          "横向时间线"
        )
      );
      this.creatMindTypeTimeVertical.push(
        new CreatMindItmeData(
          "vertical_layout_2.jpg",
          "日程安排图",
          NodeLayoutType.LAYOUT_HORIZONTAL_S,
          MindType.TIME_MAP,
          1,
          12,
          LineLayout.STRAIGHT_LINE,
          MindDisplayType.MindMap,
          false,
          "S型时间线"
        )
      );
      this.creatMindTypeTimeVertical.push(
        new CreatMindItmeData(
          "vertical_layout_4.png",
          "日程安排图",
          NodeLayoutType.LAYOUT_HORIZONTAL,
          MindType.TIME_MAP,
          1,
          32,
          LineLayout.STRAIGHT_LINE,
          MindDisplayType.MindMap,
          false,
          "横向时间线"
        )
      );
      this.creatMindTypeTimeVertical.push(
        new CreatMindItmeData(
          "vertical_layout_5.png",
          "日程安排图",
          NodeLayoutType.LAYOUT_VERTICAL,
          MindType.TIME_MAP,
          1,
          33,
          LineLayout.STRAIGHT_LINE,
          MindDisplayType.MindMap,
          false,
          "竖向时间线"
        )
      );
      //this.creatMindTypeTimeVertical.push(new CreatMindItmeData( 'vertical_layout_6.png', '日程安排图', NodeLayoutType.LAYOUT_HORIZONTAL_S, MindType.TIME_MAP, 1, 34))

      this.templateData.push(this.creatMindTypeLeftRight);
      this.templateData.push(this.creatMindTypeUnilateral);
      this.templateData.push(this.creatMindTypeBottom);
      this.templateData.push(this.creatMindTypeBubble);
      this.templateData.push(this.creatMindTypeTimeVertical);

      for (let i = 0; i < this.templateData.length; i++) {
        for (let j = 0; j < this.templateData[i].length; j++) {
          if (this.templateData[i][j] != null) {
            this.templateData[i][
              j
            ].icon = require("../../../static/img/mapIcon/res/mipmap-xxhdpi/" +
              this.templateData[i][j].icon);
          }
        }
      }
    },



    httpImageToPrefix(src) {
      return HttpServerConfig.getMediaSrc(src);
    },

    timestampToTimeDHM(timestamp) {
      return timestampToTime.formatTime(timestamp);
    },

    hideMoveFile(show, isCreated) {
      let obj = {};
      obj.show = show;
      obj.isCreated = isCreated;
      this.$emit("hideMoveFile", obj);
    },
  },
  watch: {
    moveFile: {
      handler(val) {
        if (val == true) {
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
// @font-face {
//   font-family: "fileiconfont";
//   src: url("../../../../../assets/font-icon/font_tclfjh9pcm/iconfont.eot");
//   src: url("../../../../../assets/font-icon/font_tclfjh9pcm/iconfont.eot?#iefix")
//       format("embedded-opentype"),
//     url("../../../../../assets/font-icon/font_tclfjh9pcm/iconfont.woff2")
//       format("woff2"),
//     url("../../../../../assets/font-icon/font_tclfjh9pcm/iconfont.woff")
//       format("woff"),
//     url("../../../../../assets/font-icon/font_tclfjh9pcm/iconfont.ttf")
//       format("truetype"),
//     url("../../../../../assets/font-icon/font_tclfjh9pcm/iconfont.svg#iconfont")
//       format("svg");
// }
// .fileiconfont {
//   font-family: "fileiconfont" !important;
//   font-size: 16px;
//   font-style: normal;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
// }

.move-father-box {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);

  .move-child-box {
    width: 795px;
    height: 620px;
    background-color: #fff;
    border-radius: 5px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .box-header {
      text-align: center;
      padding-top: 28px;
      font-size: 18px;
      color: #333;
    }
    .close-icon {
      width: 20px;
      height: 20px;
      position: absolute;
      right: 30px;
      top: 33px;
      cursor: pointer;
    }
    .created-content-box {
        height: 540px;
        overflow-y: auto;
        .modal-class-name {
            padding-left: 45px;
        }
    }
    .menu-silder::-webkit-scrollbar {
      // width: 340px;
      width: 8px;
      scrollbar-arrow-color: rgba(0,0,0,0.1);
    }
    .menu-silder::-webkit-scrollbar-thumb {
      border-radius: 16px;
      background: rgba(0,0,0,0.1);
    }
    .menu-silder::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px #ffffff;
      border-radius: 16px;
      background: #ffffff;
    }
  }

  // .move-child-box .move-header{
  //     height: 50px;
  // }
  // .move-child-box .move-header {
  //     padding-top: 10px;
  //     padding-left: 0px;
  // }
  // .move-child-box .move-header .mind-element{
  //   font-size: 16px;
  //   cursor: pointer;
  // }

  // .move-child-box .move-header .mind-element:nth-last-child(1) i{
  //   display: none;
  // }

  // .move-child-box .move-content {
  //   overflow: hidden;
  //     height: 260px;
  //     max-height: 260px;
  //     overflow-y: scroll;
  // }
  // .move-child-box .move-footer {
  //     display:flex;
  //     justify-content: center;

  // }
  // .move-child-box .move-footer .button-class {
  //     margin: 0 20px;
  //     margin-top: 10px;
  //     width: 60px;
  //     height: 30px;
  //     border-radius: 15px;
  //     text-align: center;
  //     line-height: 30px;
  //     font-size: 16px;
  //     background-color: #F0F2F8;
  //     cursor: pointer;
  // }
  // .move-child-box .move-footer .button-class:hover {
  //     background-color: #ff7354;
  //     color: #fff;
  // }

  //     .mind-file-list-box {
  //       //  padding-bottom: 150px;
  //        height: 260px;
  //        overflow-y: auto;
  //       .mind-file-list-box-each {
  //         height: 70px;
  //         padding: 0 20px;
  //         padding-top: 20px;
  //         cursor: pointer;
  //         .mind-each-left {
  //           width: 56px;
  //           height: 56px;
  //           float: left;
  //           margin-left: -100%;
  //         }
  //         .mind-each-center {
  //           width: 100%;
  //           float: left;
  //           .mind-each-center-title {
  //             color: #333;
  //             font-size: 16px;
  //             height: 30px;
  //             .mind-each-center-title-content {
  //               padding-left: 63px;
  //               display: flex;
  //               .title-content-name {
  //                 max-width: calc(100% - 138px);
  //                 overflow: hidden;
  //                 white-space: nowrap;
  //                 text-overflow: ellipsis;
  //               }
  //               .mind-each-center-title-stick {
  //                 background-color:rgba(0, 0, 0, 0.05);
  //                 color: #EC705A;
  //                 font-size: 12px;
  //                 padding: 0 4px;
  //                 height: 19px;
  //               }
  //             }
  //             .mind-each-center-title-sub-content {
  //               font-size: 14px;
  //               margin-top: 4px;
  //               padding-left: 63px;
  //               padding-right: 107px;
  //               color: #666;
  //               overflow: hidden;
  //               white-space: nowrap;
  //               text-overflow: ellipsis;
  //             }
  //           }
  //         }
  //         .mind-each-right {
  //           float: right;
  //           width: 100px;
  //           height: 56px;
  //           margin-left: -100px;
  //           .date-detail {
  //             color: #333;
  //             text-align: right;
  //           }
  //           .mind-file-menu-icon {
  //             float: right;
  //             padding: 2px 10px;
  //           }
  //         }
  //       }

  //       .each-box-bottom-line {
  //         height: 2px;
  //         background-color: #f6f6f6;
  //         width: calc(100% - 102px);
  //         margin-right: 20px;

  //         margin-top: 10px;
  //         float: right;
  //       }
  //     }
}
</style>